var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "build-version-wrapper",
      on: {
        mouseover: function ($event) {
          return _vm.showBuildVersion(true)
        },
        mouseleave: function ($event) {
          return _vm.showBuildVersion(false)
        },
      },
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "no-ssr",
        [
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.displayBV
              ? _c("div", { staticClass: "build-version" }, [
                  _c(
                    "div",
                    {
                      staticClass: "inner",
                      attrs: { "data-cy": "build-version-hover" },
                    },
                    [
                      _c("div", { staticClass: "build-version-text item" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("\n              Build Version\n            "),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.buildversion) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "build-date-text item" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("\n              Build Date\n            "),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.buildDate) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }